import {
  ApplicableFilter,
  FilterCategory,
  FilterItem,
  SearchFilter,
} from '../../services/types/services'

export const applySiblingFacetSelection = ({
  selectedFilters,
  preAppliedFilters,
  filters,
  filter,
  select,
}: {
  selectedFilters: ApplicableFilter[]
  preAppliedFilters: SearchFilter[]
  filters: FilterItem[]
  filter: ApplicableFilter
  select: boolean
}) => {
  if (select) return selectedFilters

  const preAppliedParentFilter = preAppliedFilters.find(
    preAppliedFilter => preAppliedFilter.key === filter.directParentKey,
  )

  if (!preAppliedParentFilter) return selectedFilters

  const parentFacet = filters.find(
    f =>
      f.__typename === 'FilterCategory' &&
      f.id === preAppliedParentFilter.group,
  ) as FilterCategory

  const matchingChildCategory = parentFacet?.children.find(
    f =>
      f.__typename === 'FilterCategory' && f.id === preAppliedParentFilter.key,
  ) as FilterCategory

  const childFacetsWithSelectedSiblings =
    matchingChildCategory?.children.reduce((acc, f) => {
      if (f.__typename === 'Filter' && f.id !== filter.id) {
        acc.push({ ...f, isSelected: true })
      }
      return acc
    }, [] as ApplicableFilter[])

  return [
    ...selectedFilters,
    ...childFacetsWithSelectedSiblings.filter(
      child => !selectedFilters.some(existing => existing.id === child.id),
    ),
  ]
}
